/* eslint-disable */
import React, { FC, ReactNode, useState } from 'react';

import './dropdown.scss';

const Button = ({
  buttonContent,
  disableClick = false,
  codeNeeded = true,
  imageNeeded = true,
  searchEnabled = false,
  buttonClassName,
  onItemSelect,
  onSearchChange,
  setOpenParent,
  data,
}) => {
  const [open, setOpen] = useState(false);
  const clickEvent = () => {
    if  (disableClick)  return;
    setOpenParent;
    setOpen(!open);
  };
  return (
    <div className="dd-wrapper">
      <div className={buttonClassName} onClick={clickEvent}>
        <div className="dd-header-title">{buttonContent}</div>
      </div>
      {open && (
        <div className="dd-click-outside" onClick={() => setOpen(false)} />
      )}
      {open && (
        <div className="dd-list-wrapper">
          {searchEnabled && (
            <div className="dd-list-header">
              <input
                type="text"
                className="dd-search-field"
                placeholder="Search"
                onChange={(e) => onSearchChange(e)}
              />
            </div>
          )}

          <ul className="dd-list" style={{ disabled: true }}>
            {data.map((item) => (
              <li
                className="dd-list-item"
                key={item.id}
                onClick={() => {
                  setOpen(false);
                  onItemSelect(item);
                }}
              >
                {/* <span className="dd-list-item-left">{item.leftContent}</span> */}
                {imageNeeded ? (
                  <div className="dd-list-item-left">
                    <img src={item.iconName} />
                  </div>
                ) : null}
                <div
                  className="dd-list-item-main"
                  style={imageNeeded ? {} : { marginLeft: '0px' }}
                >
                  {item.title}
                </div>
                <div className="dd-list-item-auto-spacer"></div>
                {codeNeeded ? (
                  <div className="dd-list-item-right">{item.subtitle}</div>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Button;
